import { tabletBreakpoint } from 'react-components'
import styled, { css } from 'styled-components'
import { FastResponderIcon } from '../../common/icons'

export const PriceInputWrapper = styled.div<{ layout: 'compact' | 'stretched' }>`
    display: ${({ theme }) => theme.style.display.flex};
    flex-direction: ${({ theme }) => theme.style.flexDirection.row};
    flex-wrap: ${({ theme }) => theme.style.flexWrap.wrap};
    flex: 1;
    gap: ${({ theme }) => theme.spacing.small};
    width: 100%;
    margin-bottom: ${({ theme }) => theme.spacing.small};
    justify-content: ${({ theme }) => theme.style.justifyContent.spaceBetween};
    align-items: flex-start;
    border-radius: ${({ theme }) => theme.typography.border.radius.medium};
`
export const PriceInput = styled.div<{ layout: 'compact' | 'stretched' }>(
    ({ theme, layout }) => css`
        display: ${theme.style.display.flex};
        /* min-width is calculated as per the gap given in PriceInputWrapper */
        min-width: ${layout === 'stretched' ? '100%' : `calc(50% - (${theme.spacing.small} / 2))`};
    `,
)

export const PriceComponentSeparator = styled.div`
    display: ${({ theme }) => theme.style.display.flex};
    flex: 1;
    height: 1px;
    border: 1px dotted #d3d3d3;
    margin: ${({ theme }) => `${theme.spacing.small} 0`};
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        margin: ${({ theme }) => `${theme.spacing.medium} 0`};
    }
`

export const PriceCostContentWrapper = styled.div`
    display: ${({ theme }) => theme.style.display.flex};
    flex-direction: ${({ theme }) => theme.style.flexDirection.row};
    flex: 1;
    padding: 2px 0;
`

export const CostList = styled.div(
    ({ theme }) => `
        display: flex;
        flex-direction: column;
        gap: ${theme.spacing.xxSmall};
        padding: 0.125rem 0;
    `,
)

export const CostRow = styled.div(
    ({ theme }) => `
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: ${theme.spacing.small};
    `,
)

export const CTAButton = styled.div`
    display: flex;
    flex: 1;
    background: ${props => props.theme.colors.white};
`
export const ButtonText = styled.div``

export const QuickResponderTag = styled.div`
    display: inline-flex;
    align-items: center;
    padding: 0.25rem 0.5rem;
    margin: 0.375rem 0;
    border-radius: 0.3125rem;
    background-color: #f9f5ff;
    color: #6b43a4;
    font-size: 0.6875rem;
    line-height: 1rem;
    font-weight: ${({ theme }) => theme.typography.font.weight.bold};
    width: fit-content;
`

export const StyledFastResponderIcon = styled(FastResponderIcon)`
    width: 0.8125rem;
    height: 0.8125rem;
    margin-right: 0.375rem;
    vertical-align: middle;
`

export const DisclaimerContainer = styled.div`
    display: flex;
    width: 100%;
    font-family: ${props => props.theme.typography.font.family.lato};
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 1rem;
    letter-spacing: 0.2px;
    color: #6f6f6f;
    justify-content: center;
`
